<template>
  <div>
    <card v-if="isLoading"
      :title="$t('pages.payment_checkout.loading') ">
    </card>
    <card v-if="successful && !isLoading"
      :title="$t('pages.payment_checkout.payment_successful') ">
      <el-button class="button" @click="next()" :round=true>
        {{ $t("pages.payment_checkout.continue").toUpperCase() }}
      </el-button>
      <el-button class="button" @click="goBack()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.go_back").toUpperCase() }}
      </el-button>
    </card>
    <card v-if="!successful && !declined && !errorToken && !inProcessing && !isLoading"
      :title="$t('pages.payment_checkout.payment_unsuccessful') ">
      <p> {{ $t('pages.payment_checkout.payment_declined_message') }} </p>
      <el-button class="button" @click="goBack()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.go_back").toUpperCase() }}
      </el-button>
    </card>
    <card v-if="!successful && errorToken && !declined && !inProcessing && !isLoading"
      :title="$t('pages.payment_checkout.payment_error_token') ">
      <el-button class="button" @click="retry()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.retry").toUpperCase() }}
      </el-button>
      <el-button class="button" @click="goBack()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.go_back").toUpperCase() }}
      </el-button>
    </card>
    <card v-if="!successful && !errorToken && !declined && inProcessing && !isLoading"
      :title="$t('pages.payment_checkout.payment_in_processing') ">
      <el-button class="button" @click="retry()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.refresh").toUpperCase() }}
      </el-button>
      <el-button class="button" @click="goBack()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.go_back").toUpperCase() }}
      </el-button>
    </card>
    <card v-if="!successful && declined && !errorToken && !inProcessing && !isLoading"
      :title="$t('pages.payment_checkout.payment_declined').toUpperCase() ">
      <p> {{ $t('pages.payment_checkout.payment_declined_message') }} </p>
      <el-button class="button" @click="goBack()" v-loading.fullscreen.lock="isLoading" :round=true>
        {{ $t("pages.payment_checkout.go_back").toUpperCase() }}
      </el-button>
    </card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapMutations, mapGetters } = createNamespacedHelpers(
  "session"
);

export default {
  data() {
    return {
      isLoading: true,
      successful: true,
      declined: false,
      errorToken: false,
      inProcessing: false,
      vueInstance: undefined
    };
  },
  async mounted() {
    if (this.$route.query.id) {
      // Call MS payments to know whether payment went through
      
      try {
        let response = await this.checkPaymentStatus(this.$route.query.id);

        // let response = {
        //   status : 200,
        //   data : {
        //     status_code : 1000,
        //     data: {
        //       token: {
        //         country_code : "ES",
        //         party_id : "GLG",
        //         uid : "012345678",
        //         contract_id : "DE8ACC12E46L891",
        //         group_id : "DF000-2001-8999",
        //         issuer : "TheNewMotion",
        //         type : "RFID",
        //         valid: true,
        //         visual_number : "DF000-2001-8999-1",
        //         whitelist : "ALWAYS"
        //       }
        //     }
        //   }
        // }

        this.$console("log", JSON.stringify(response.data))

        if (response.status === 200) {

          if (response.data.status_code === 1000) {
            const token = response.data.data.token;
            // save token in vuex store, and set status to pending
            this.saveToken({ token: token });
            this.$console("log", token.uid)
          }
          else if (response.data.status_code === 3001) { // declined
            this.successful = false;
            this.declined = true;
            this.errorToken = false;
            this.inProcessing = false;
          } 
          else if (response.data.status_code === 3002) { // error on the token
            this.successful = false;
            this.errorToken = true;
            this.declined = false;
            this.inProcessing = false;
          } else if (response.data.status_code === 3003) { // in processing
            this.successful = false;
            this.errorToken = false;
            this.declined = false;
            this.inProcessing = true;
          }
        } else {
          this.successful = false;
        }
      } catch (error) {
        this.$console("error", error);
        this.successful = false;
      }

      this.isLoading = false;

    } else this.successful = false;
  },
  methods: {
    ...mapActions(["checkPaymentStatus", "getCommand", "cancelPayment"]),
    ...mapMutations(["saveToken", "changeStatusToCreated"]),
    ...mapGetters(["getSessionToken", "getSessionStatus","getLocation", "getCommandSent", "getPaymentId"]),
    next() {
      this.$router.replace({
        name: "EvsePicker",
        params: {
          reload: false,
          from: {
            name: "PaymentCheckout"
          }
        }
      });
    },
    async goBack() {
      const status = this.getSessionStatus();
      if(
        status === "Authorized" || 
        (status === "Pending" && !this.getCommandSent())
      ){
        try {
          this.isLoading = true
          let response = await this.cancelPayment(this.getPaymentId());

          if (response.status === 200) {
            this.$store.commit("session/changeStatusToCreated"); 
            this.$message({
              type: "success",
              message: this.$t('pages.payment_checkout.payment_cancelled_success')
            });
            this.isLoading = false
          }
        } catch (error) {
          this.$console("error", error);
          this.$message({
            type: "error",
            message: this.$t('pages.payment_checkout.payment_cancelled_error')
          });
          this.isLoading = false
        }   
      }

      const location = this.getLocation();

      const params = {
        countryCode: location.countryCode,
        partyId: location.partyId,
        locationId: location.locationId,
        reload: false
      }
      this.$router.replace({
        name: "PaymentMethod",
        params
      });
    },
    async retry(){
      this.isLoading = true;
      
      try {
        let response = await this.checkPaymentStatus(this.$route.query.id);

        this.$console("log",response.status)
        this.$console("log",response.data.status)

        if (response.status === 200) {

          if (response.data.status_code === 1000) {
            const token = response.data.data.token;
            // save token in vuex store, and set status to pending
            this.saveToken({ token: token });
            this.successful = true;
            this.declined = false;
            this.errorToken = false;
            this.inProcessing = false;
          }
          else if (response.data.status_code === 3002) { // error on the token
            this.successful = false;
            this.errorToken = true;
            this.declined = false;
            this.inProcessing = false;
          } else if (response.data.status_code === 3003) { // in processing
            this.successful = false;
            this.errorToken = false;
            this.declined = false;
            this.inProcessing = true;
          }
        } else {
          this.successful = false;
        }
      } catch (error) {
        this.successful = false;
      }
      
      this.isLoading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>